var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H8C6.34315 5 5 6.34315 5 8V12C5 13.6569 6.34315 15 8 15H12C13.6569 15 15 13.6569 15 12V8C15 6.34315 13.6569 5 12 5Z",
    fill: "#112C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5H20C18.3431 5 17 6.34315 17 8V12C17 13.6569 18.3431 15 20 15H24C25.6569 15 27 13.6569 27 12V8C27 6.34315 25.6569 5 24 5Z",
    fill: "#112C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H8C6.34315 17 5 18.3431 5 20V24C5 25.6569 6.34315 27 8 27H12C13.6569 27 15 25.6569 15 24V20C15 18.3431 13.6569 17 12 17Z",
    fill: "#112C54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H20C18.3431 17 17 18.3431 17 20V24C17 25.6569 18.3431 27 20 27H24C25.6569 27 27 25.6569 27 24V20C27 18.3431 25.6569 17 24 17Z",
    fill: "#112C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid-view.b4dd07e5609922bbf1392a73fd65e2f9.svg";
export { ForwardRef as ReactComponent };